import { render } from "./PoiGz.vue?vue&type=template&id=7f987ef3&scoped=true"
import script from "./PoiGz.vue?vue&type=script&lang=js"
export * from "./PoiGz.vue?vue&type=script&lang=js"

import "./PoiGz.vue?vue&type=style&index=0&id=7f987ef3&scoped=true&lang=scss"
import "./PoiGz.vue?vue&type=style&index=1&id=7f987ef3&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f987ef3"]])

export default __exports__